<template>
	<div class="home">
		<div class="header" id="header"><div class="inner-block"><h1>In mare siamo come gli squali. <br>Non ci fermiamo mai.</h1></div></div>
		<div class="block" id="storia">
			<div class="inner-block">
				<div class="photos">
					<div class="photo vertical" :style="{'background-image':'url('+require('../assets/images/SqualoSport-interno3.jpeg')+')'}">
					</div>
					<div class="photo horizontal" :style="{'background-image':'url('+require('../assets/images/SqualoSport-interno5.jpeg')+')'}">
					</div>
					<div class="photo small" :style="{'background-image':'url('+require('../assets/images/SqualoSport-interno7.jpeg')+')'}">
					</div>
				</div>
				<div class="text">
					<h2>Dal 1969 ci apriamo al concetto di mare e di estate.</h2><p> Lo facciamo attraverso la scelta di strumenti, di attrezzature tecniche, di abbigliamento. Perché per noi il mare non è solo un divertimento, è parte della vita. È parte dell’amore. È uno spettacolo da vivere ogni giorno, col sole e con la pioggia, con le onde e con il vento, con la calma e con le burrasche. </p>
				</div>

			</div>
		</div>
		<div class="block right" id="mare">
			<div class="inner-block">
				<div class="photos">
					<div class="photo vertical" :style="{'background-image':'url('+require('../assets/images/SqualoSport-interno4.jpeg')+')'}">
					</div>
					<div class="photo horizontal" :style="{'background-image':'url('+require('../assets/images/SqualoSport-interno8.jpeg')+')'}">
					</div>
					<div class="photo small" :style="{'background-image':'url('+require('../assets/images/SqualoSport-interno10.jpeg')+')'}">
					</div>
				</div>
				<div class="text"><h2>Per noi il mare è una grande opportunità, una scelta, la pace.</h2><p> Ma anche l’avventura, la passione, la scoperta. È il sorriso di un bambino che vede i pesciolini, la quiete di una serata al porto, il rumore delle barche. Per noi il mare è un’attitudine da portare in città, da vivere ogni giorno. E poi sono storie, leggende, racconti, passione, risate, eleganza, felicità. Siete pronti per una grande avventura tra le onde?</p>
				</div>
			</div>
		</div>
		<div class="block parlami" id="parlami">
			<div class="inner-block">
				<div class="photos">
					<div class="photo vertical" :style="{'background-image':'url('+require('../assets/images/ParlamiDiMare-1.jpeg')+')'}">
					</div>
					<div class="photo horizontal" :style="{'background-image':'url('+require('../assets/images/ParlamiDiMare-2.jpeg')+')'}">
					</div>
					<div class="photo small" :style="{'background-image':'url('+require('../assets/images/ParlamiDiMare-3.jpeg')+')'}">
					</div>
				</div>
				<div class="text"><h2>Parlami di Mare</h2><p>Parlami di mare è la capsule edition di Squalo Sport per l’estate 2018. È il nostro modo di
				raccontare il mare, di interpretarlo, di viverlo. Un progetto nato per gioco, la voglia di comunicare, di divertirci e condividere il nostro modo di vivere il mare.</p>
			</div>
		</div>
		<div class="block brands" id="brands">
			<div class="inner-block">
				<h2>I nostri brand</h2>
				<ul>
					<li v-for="(logo, index) in [0,1,2,3,5,6,7,8]" :key="index"><img :src="require('../assets/images/logos/what-we-sell_000' + logo + '.jpg')" alt=""></li>
				</ul>
			</div>
		</div>
	</div>
	<div class="footer"><div class="inner-block">
		<p><strong>Squalo Sport</strong> | Via Nazionale 30, 07020 Palau (OT) | +39 0789 709 709 | info@squalosport.it | © 2018 Squalo Sport</p>
	</div></div>
</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'home'
}
</script>

<style lang="scss">

@import "../assets/css/main.scss";

</style>